const PdfHtmlContentToken = ({
  invoice,
  invoiceSetting,
  invoiceImeis,
  inputs,
  formattedDateTime,
  totalPricePrintCustomize,
  totalItemsPrintCustomize,
  styles,
  totalPrice,
  totalQty,
  BASE_URL,
  exChangeImeis,
}) => {
  const grandTotal = Number.parseFloat(
    (
      Number(totalPrice) +
      Number(invoice?.vat || 0) +
      Number(invoice?.tax || 0) +
      Number(invoice?.delivery_fee || 0)
    ).toFixed(2),
  );
  const paidAmount = Number(invoice.paid_amount && invoice.paid_amount !== 0 ? invoice.paid_amount : 0);
  const dueAmount = grandTotal - paidAmount;

  const groupedByKitchen = {};
  invoice?.sales_details?.forEach((item) => {
    const kitchenId = item.product_info?.kitchen_id;
    if (!kitchenId) return;

    if (!groupedByKitchen[kitchenId]) {
      groupedByKitchen[kitchenId] = {
        kitchenName: item.product_info?.kitchen?.name || "Unnamed Kitchen",
        items: []
      };
    }
    groupedByKitchen[kitchenId].items.push(item);
  });

  return (
    <div className="hidden">
      <style>
        {`
          @media print {
            @page {
              size: 3in auto;
              margin: 0mm;
            }
            body {
              width: 3in;
              margin: 0;
              padding: 0;
            }
            .receipt-container {
              width: 3in;
              padding: 0.1in;
              font-size: 10px;
              font-family: 'Courier New', monospace;
            }
            .receipt-header {
              text-align: center;
              margin-bottom: 0.1in;
            }
            .receipt-table {
              width: 100%;
              border-collapse: collapse;
            }
            .receipt-table th, .receipt-table td {
              padding: 2px;
              text-align: left;
            }
            .receipt-table th {
              border-bottom: 1px dashed #000;
            }
            .receipt-divider {
              border-bottom: 1px dashed #000;
              margin: 0.1in 0;
            }
            .receipt-footer {
              text-align: center;
              margin-top: 0.1in;
              font-size: 9px;
            }
            .token-number {
              font-size: 18px;
              font-weight: bold;
            }
            .shop-name {
              font-size: 12px;
              font-weight: bold;
            }
          }
        `}
      </style>

      {Object.entries(groupedByKitchen).map(([kitchenId, group], index) => {
        let rowCounter = 0;
        let subtotalPrice = 0;
        const processedProductIds = new Set();

        return (
          <div key={kitchenId} id={`pdfKitchenToken-${kitchenId}`} className="hidden">
            <div className="receipt-container print-wrapper">
              <div className="receipt-header">
                <div className="shop-name">{invoiceSetting?.shop_name || "RESTAURANT NAME"}</div>
                {invoiceSetting?.slogan && <div>{invoiceSetting?.slogan}</div>}
                <div className="token-number" style={{ color: invoiceSetting?.first_code || "#000" }}>
                  TOKEN #{invoice.invoice_id.split("-").pop()}
                </div>
                <div className="token-number" style={{ color: invoiceSetting?.first_code || "#000" }}>
                  {invoice?.table?.table_name}
                </div>
                <div><strong>Kitchen: {group.kitchenName}</strong></div>
                <div>{formattedDateTime}</div>
              </div>

              <div className="receipt-divider"></div>

              <table className="receipt-table">
                <thead>
                  <tr>
                    <th style={{ width: "10%" }}>#</th>
                    <th style={{ width: "70%" }}>Item</th>
                    <th style={{ width: "20%" }}>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {group.items.map((item) => {
                    const findImeis = invoiceImeis.filter((imei) => imei.product_id === item.product_id);

                    if (processedProductIds.has(item.product_id)) return null;
                    processedProductIds.add(item.product_id);

                    if (findImeis.length > 0) {
                      const qty = findImeis.length;
                      const itemSubtotal = findImeis.reduce((acc, prod) => acc + prod.sale_price, 0);
                      subtotalPrice += itemSubtotal;

                      return findImeis.map((imei) => (
                        <tr key={imei.id}>
                          <td>{++rowCounter}</td>
                          <td>
                            <strong>
                              {`${imei?.product_name || ""} ${imei?.color || ""} ${imei?.storage ? imei.storage + " GB" : ""} - ${imei?.region || ""} ${imei?.battery_life ? `(BH-${imei.battery_life}%)` : ""}`}
                            </strong>
                          </td>
                          <td>1</td>
                        </tr>
                      ));
                    } else {
                      subtotalPrice += item.qty * item.price;

                      return (
                        <tr key={item.id}>
                          <td><strong>{++rowCounter}</strong></td>
                          <td><strong>{item.product_info?.name}</strong></td>
                          <td><strong>{item.qty}</strong></td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>

              <div className="receipt-divider"></div>

              <div className="receipt-footer">
                <p>Thank you for your order!</p>
                {invoice?.customer?.name && <p>Customer: {invoice.customer.name}</p>}
                {invoice?.customer?.phone && <p>Phone: {invoice.customer.phone}</p>}
                <p>{new Date().toLocaleString()}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PdfHtmlContentToken;